class WritingModel {
  constructor(name = "", description = "") {
    this.name = name;
    this.description = description;
    this.template = [];
    this.uploadedFiles = [];
    this.target_audience = "";
    this.expected_length = "";
    this.tone = "";
    this.outline = "";
  }
}

export default WritingModel;
